<template>

  <v-select v-bind="{ ...$attrs, ...commonAttrs }">

    <!-- https://stackoverflow.com/a/50892881/19018560 -->
    <!-- <template v-for="(_, slot) of $slots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope"/></template> -->

    <!-- https://gist.github.com/loilo/73c55ed04917ecf5d682ec70a2a1b8e2 -->
    <!-- <template v-for="(_, name) in $slots" v-slot:[name]="slotData"><slot :name="name" v-bind="slotData" /></template> -->

    <!-- https://stackoverflow.com/a/71678136/19018560 -->
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData || {}" />
    </template>

  </v-select>

</template>

<script setup>

/**
 * A simple wrapper for Vuetify's <v-select>.
 * 
 * https://dev.to/kouts/create-wrapper-components-for-vuetify-components-2aah
 * https://v3-migration.vuejs.org/breaking-changes/listeners-removed.html
 */

import { computed, useAttrs } from 'vue'

const props = defineProps({

  validator: {
    type: Object,
  },

  required: {
    type: Boolean,
    default: false,
  },

})

const attrs = useAttrs()

const commonAttrs = computed(() => {

  // override 

  const output = {}

  if (props.validator) {
    output.validator = null // don't pass the validator prop along to v-select
    output.errorMessages = props.validator.$errors.map(e => e.$message)
  }

  // If the readonly prop was passed, automatically use the plain variant
  if ('readonly' in attrs && (!!attrs.readonly || attrs.readonly === '')) {
    output.variant = 'plain'
  }

  if (props.required) {
    if ('class' in attrs) {
      output.class = attrs.class + ' v-input--required'
    } else {
      output.class = 'v-input--required'
    }
  }

  return output

})

</script>
